import React from "react";
import { useTranslation } from "react-i18next";
import { Container, Row, Col } from "react-bootstrap";
import { FaCheck } from "react-icons/fa";
// import signature from "../../img/signature.webp";
import signature from "../../img/newsignature.webp";
// import Img1 from "../../img/about.webp";
import Img1 from "../../img/newabout.webp";
import "./style.css";
const About = () => {
  const { t } = useTranslation();
  return (
    <section className="gauto-about-area section_70">
      <Container>
        <Row>
          <Col lg={6}>
            <div className="about-left">
              <h4>About Us</h4>
              <h2>Welcome to Sher East Africa</h2>
              <p>{t("about_text")}</p>
              <div className="about-list">
                <ul>
                  <li>
                    <span>
                      <FaCheck />
                    </span>
                    {t("trusted_name")}
                  </li>
                  <li>
                    <span>
                      <FaCheck />
                    </span>
                    {t("deal_brands")}
                  </li>
                  <li>
                    <span>
                      <FaCheck />
                    </span>
                    {t("larger_stocks")}
                  </li>
                  <li>
                    <span>
                      <FaCheck />
                    </span>
                    {t("worldwide_location")}
                  </li>
                </ul>
              </div>
              <div className="about-signature">
                <div className="signature-left">
                  <img src={signature} alt="signature" />
                </div>
                <div className="signature-right">
                  <h3>Arusha Tanzania</h3>
                  <p>Njiro Industrial Area</p>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6}>
            <div className="about-right">
              <img src={Img1} alt="car" />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
export default About;
